import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

const Float = ({ children, speed = 50, className, duration = 2 }) => (
  <StyledFloat
    className={className}
    style={{
      '--float-y': `${speed}px`,
      animationDuration: `${duration}s`,
    }}
  >
    {children}
  </StyledFloat>
);

const floatAnimation = keyframes`
  0%,
  100% {
    transform: translate3d(0, var(--float-y), 0);
  }

  50% {
    transform: translate3d(0, 0, 0);
  }
`;

const StyledFloat = styled.div`
  animation-name: ${floatAnimation};
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  will-change: transform;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

Float.propTypes = {
  children: PropTypes.node,
  speed: PropTypes.number,
  duration: PropTypes.number,
  className: PropTypes.string,
};

export default Float;
